import { combineReducers } from "redux";
import filterReducer from "./filter/filterReducer";
import productReducer from "./products/productReducer";

const rootReducer = combineReducers({
    book: productReducer,
    filter: filterReducer
})

export default rootReducer;